import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { getThemeColor } from '@/utils/themes'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq, aspectRatio } from '@/utils/helpers'
import Typography from '@/components/common/Typography'
import Image from '@/components/common/Image'
import GhostButton from '@/components/common/GhostButton'
import Tag from '@/components/common/Tag'

const ProjectPostCard = props => {
  const { theme, featuredImage, title, client, clientType, platforms, stack, shortDescription, path, request, ...others } = props
  return (
    <Root theme={theme} {...others}>
      <Thumbnail theme={theme}><Image css={styles.Image} fluid={featuredImage.childImageSharp.fluid} alt={props.name} objFit="contain"/></Thumbnail>
      <Main theme={theme}>
        <ClientType color="primary">{clientType}</ClientType>
        <Title variant="h3">{title}</Title>
        <Description variant="body2">{shortDescription}</Description>
        {((platforms && platforms.length) || (stack && stack.length)) && (
          <Lists>
            {platforms && platforms.length && (
              <List>
                <List_Title variant="caption2" theme={theme}>種別</List_Title>
                <List_Parent>
                  {platforms.map((name, index) => (
                    <List_Child key={index} variant="caption2" component="li">{name}</List_Child>
                  ))}
                </List_Parent>
              </List>
            )}
            {stack && stack.length && (
              <List>
                <List_Title variant="caption2" theme={theme}>言語・ツール</List_Title>
                <List_Parent>
                  {stack.map((name, index) => (
                    <StackList_Child key={index} variant="caption2" component="li" theme={theme}>{name}</StackList_Child>
                  ))}
                </List_Parent>
              </List>
            )}
          </Lists>
        )}
        <Actions><Button component={Link} to={path}>詳細を見る</Button></Actions>
      </Main>
    </Root>
  )
}

const Root = styled.div`
  @media ${mq.and(desktop, laptop, tabletL)} {
    display: flex;
  }
`

const Thumbnail = styled.div`
  @media ${mq.and(desktop, laptop, tabletL)} {
    flex-shrink: 0;
    flex-grow: 0;
    width: 50%;
  }
  ${aspectRatio(964, 549)};
  background-color: ${props => props.theme.scale[800]};
`

const Main = styled.div`
  @media ${mq.and(desktop, laptop, tabletL)} {
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    padding: 32px 48px;
  }
  @media ${mq.and(tabletS)} {
    padding: 40px 24px;
  }
  @media ${mq.and(mobile)} {
    padding: 32px 16px;
  }
  background-color: ${props => props.theme.scale[600]};
`

const ClientType = styled(Tag)`
  flex-grow: 0;
  flex-shrink: 0;
`

const Title = styled(Typography)`
  flex-shrink: 0;
  flex-grow: 0;
  margin-top: 24px;
  width: 100%;
`

const Description = styled(Typography)`
  flex-shrink: 1;
  flex-grow: 1;
  margin-top: 20px;
  width: 100%;
`

const Lists = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: 24px;
  width: 100%;
`

const List = styled.div`
  &:not(:first-of-type) {
    margin-top: 2px;
  }
  display: flex;
`

const List_Title = styled(Typography)`
  flex-grow: 0;
  flex-shrink: 0;
  color: ${props => props.theme.scale[300]};
`

const List_Parent = styled.ul`
  margin-left: 8px;
  display: flex;
  flex-wrap: wrap;
`

const List_Child = styled(Typography)`
  margin-right: 4px;
  &::after {
    content: ',';
  }
  &:last-of-type::after {
    content: '';
  }
`

const StackList_Child = styled(List_Child)`
  color: ${props => getThemeColor('primary', props.theme)};
`

const Actions = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  margin-top: 42px;
  width: 100%;
  text-align: right;
  @media ${mq.and(tabletS, mobile)} {
    margin-top: 32px;
    text-align: center;
  }
`

const Button = styled(GhostButton)`
  width: 180px;
`

const styles = {
  Image: css`
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `
}

export default ThemeConsumer(ProjectPostCard)
